import * as React from 'react';
import cn from 'classnames';
import styles from './styles.module.css';

interface NavTabProps {
  name: string;
  onSelect: () => void;
  active?: boolean;
  disabled?: boolean;
  invertColors?: boolean;
}

export const NavTab: React.FC<NavTabProps> = ({
  name,
  onSelect,
  active = false,
  disabled = false,
  invertColors = false,
}) => {
  const classes = [
    invertColors ? styles.navLinkInverted : styles.navLink,
    styles.navTabs,
    active ? `${styles.active} active` : '',
    disabled ? styles.disabled : '',
  ];
  return (
    <li
      className={cn(styles.navTabs)}
      data-heading={name}
      data-active={active}
      onClick={onSelect}
    >
      <a href="#" onClick={onSelect} className={cn(classes)}>
        {name}
      </a>
    </li>
  );
};

interface TabListProps {
  children: React.ReactNode;
  className?: string;
}

export const TabList: React.FC<TabListProps> = ({ children, className = '' }) => (
  <ul className={cn('nav', className)}>{children}</ul>
);

interface TabPanelProps {
  active?: boolean;
  children: React.ReactNode;
}
export const TabPanel: React.FC<TabPanelProps> = ({ active = false, children }) => {
  return (
    <>
      {active && (
        <div className={cn('tab-pane', styles.tabPane, active ? 'active' : '')}>
          {children}
        </div>
      )}
    </>
  );
};

interface TabContentProps {
  children: React.ReactNode;
}

export const TabContent: React.FC<TabContentProps> = ({ children }) => (
  <div className={cn('tab-content')}>{children}</div>
);

interface TabsetProps {
  children: React.ReactNode;
  style?: string;
}

export const Tabset: React.FC<TabsetProps> = ({ children, style }) => (
  <div className={cn('tab-set', styles.nav, style)}>{children}</div>
);
